import { firestoreAction } from "vuexfire";
import { collection } from "@/store/modules/db";
function camRegisterCollection() {
  return collection("emails/data/campaigns");
}
function camMsgCollection(campaignId) {
  return collection("emails/data/messages").where("campaign", "==", campaignId);
}
export default {
  namespaced: true,
  state: () => ({
    currentHtml: null,
    campaignList: [],
    currentCampaign: null,
    currentCampaignId: null,
    templateUrlEditMode: false,
    campaignMessages: []
  }),
  mutations: {
    updateCurrentHtml(state, html) {
      state.currentHtml = html;
    },
    updateCurrentCampaignId(state, id) {
      state.currentCampaignId = id;
    },
    async updateCurrentCampaign(state, obj) {
      let id = state.currentCampaignId;

      const doc = camRegisterCollection().doc(id);
      await doc.set(obj, { merge: true });
    }
  },
  actions: {
    updateCurrentHtml({ commit }, html) {
      commit("updateCurrentHtml", html);
    },
    bindCampaignList: firestoreAction(context => {
      // context contains all original properties like commit, state, etc
      // and adds `bindFirestoreRef` and `unbindFirestoreRef`
      // we return the promise returned by `bindFirestoreRef` that will
      // resolve once data is ready
      return context.bindFirestoreRef("campaignList", camRegisterCollection());
    }),
    bindCampaignMessages: firestoreAction((context, campaignId) => {
      return context
        .bindFirestoreRef("campaignMessages", camMsgCollection(campaignId))
        .catch(e => {
          console.log(e);
        });
    }),

    setCurrentCampaign: firestoreAction(
      ({ state, commit, unbindFirestoreRef, bindFirestoreRef }, id) => {
        commit("updateCurrentCampaignId", id);
        state.templateUrlEditMode = false;
        if (!id) {
          return unbindFirestoreRef("currentCampaign");
        }
        // console.log(id);
        return bindFirestoreRef(
          "currentCampaign",
          camRegisterCollection().doc(id)
        ).then(() => {
          const template = state.currentCampaign.templateUrl;
          if (!template) state.templateUrlEditMode = true;
        });
      }
    ),
    templateEditModeOn: firestoreAction(({ state }) => {
      state.templateUrlEditMode = true;
    }),
    templateEditModeOff: firestoreAction(({ state }) => {
      state.templateUrlEditMode = false;
    }),
    updateTemplateUrl: firestoreAction(({ state }, url) => {
      return camRegisterCollection()
        .doc(state.currentCampaign.id)
        .update({ templateUrl: url })
        .then(() => {
          state.templateUrlEditMode = false;
        });
    }),
    updateEdmInfo: firestoreAction(({ state }, info) => {
      return camRegisterCollection()
        .doc(state.currentCampaign.id)
        .update(info)
        .then(() => {
          state.templateUrlEditMode = false;
        });
    }),
    setLeadProjects({ state }, projects) {
      return camRegisterCollection()
        .doc(state.currentCampaign.id)
        .update({ leads: projects });
    }
  },
  getters: {
    currentHtml: state => state.currentHtml,
    currentCampaignId: state => state.currentCampaignId,
    currentCampaign: state => state.currentCampaign,
    currentTemplateUrl: state =>
      state.currentCampaign ? state.currentCampaign.templateUrl : null,
    campaignList: state => state.campaignList,
    templateUrlEditMode: state => state.templateUrlEditMode
  }
};
